import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import { useCurrentGallection } from '../../_hocs/withCurrentGallection';
import { MediaSourceType } from '../../types';
import { showNewFolderPopup, hideNewFolderPopup } from '../../actions';
import { getCurrentUserHasCore } from '../../../publicSession/selectors';
import { isPremiumGallection } from '../../../utils/gallections';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import NewGallectionPopup from '../NewGallectionPopup';
import Flex from '@wix/da-ds/pkg/Flex';
import { getIsShowingNewGallectionPopup } from '../../selectors';
import { URLS } from '@wix/da-url';
import { useSelector } from 'react-redux';
import { useMMSelector, useMMDispatchActions } from '../../_hocs/withOwnReduxStore';
import { useGlobalPrivs } from '../../_hocs/withGlobalPrivs';
export const AddGallectionButton = /*#__PURE__*/ React.memo(({ isSecondary })=>{
    const { t } = useTranslation();
    const hasCore = useSelector(getCurrentUserHasCore);
    const { currentMediaSource } = useCurrentMediaSource();
    const { canCreateGalleryFolder } = useGlobalPrivs();
    const { currentGallection, currentFolderId } = useCurrentGallection();
    const { isShowingNewGallectionPopup } = useMMSelector((state)=>({
            isShowingNewGallectionPopup: getIsShowingNewGallectionPopup(state)
        }));
    const actions = useMMDispatchActions({
        showNewFolderPopup,
        hideNewFolderPopup
    });
    const buttonText = useMemo(()=>{
        switch(currentMediaSource){
            case MediaSourceType.STASH:
                return t('mediapopup.newStash');
            case MediaSourceType.GALLERY:
                if (isSecondary) {
                    return t('mediapopup.newGallery.newSubGallery');
                }
                return t('mediapopup.newGallery');
            case MediaSourceType.PRIVATE_COLLECTION:
                return t('mediapopup.newPrivateCollection');
            case MediaSourceType.COLLECTION:
            default:
                if (isSecondary) {
                    return t('mediapopup.newCollection.newSubCollection');
                }
                return t('mediapopup.newCollection');
        }
    }, [
        currentMediaSource,
        isSecondary,
        t
    ]);
    if (currentMediaSource === MediaSourceType.GALLERY && !canCreateGalleryFolder) {
        return null;
    }
    if (isPremiumGallection(currentGallection)) {
        // completely hidden
        return null;
    }
    const isForSubfolders = !!currentFolderId;
    const restrictedToCore = isForSubfolders && !hasCore;
    const DSButton = isSecondary ? TextButton : GhostButton;
    const button = /*#__PURE__*/ React.createElement(DSButton, {
        variant: "main",
        size: "large",
        onClick: actions.showNewFolderPopup,
        disabled: isForSubfolders && !hasCore,
        icon: AddIcon
    }, buttonText);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, restrictedToCore ? /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        style: {
            gap: 4
        }
    }, /*#__PURE__*/ React.createElement(CoreBadge, {
        size: "large"
    }), /*#__PURE__*/ React.createElement("a", {
        href: URLS.CORE_MEMBERSHIP,
        target: "_blank",
        rel: "noopener noreferrer"
    }, button)) : button, isShowingNewGallectionPopup && /*#__PURE__*/ React.createElement(NewGallectionPopup, {
        onCancel: actions.hideNewFolderPopup,
        onDone: actions.hideNewFolderPopup
    }));
});
AddGallectionButton.displayName = 'AddGallectionButton';
export default AddGallectionButton;
